import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ActionAI from './components/ActionAI';
import Writing from './components/Writing';
import FeaturedIn from './components/FeaturedIn';

import Speaking from './components/Speaking';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      {/* <Customizer /> */}
      <Navbar />
      <Hero />
      <About />
      <ActionAI />
      <Writing />
      <FeaturedIn />
      <Speaking />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
